import { ArrowRight } from '@outdoor-voices/ui';
import { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { parseMarkdown } from './utils';
import { ProductContext } from '../context';
import css from './index.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FabricLink = function FabricLink() {
  var _useContext = useContext(ProductContext),
      fabric = _useContext.fabric;

  if (!fabric) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var title = fabric.url ? /*#__PURE__*/_jsxs("a", {
    "aria-label": "This product is made with the ".concat(fabric.title, " fabric.\n      Click to navigate to the ").concat(fabric.title, " collection of products."),
    href: "".concat(fabric.url, "?fabric=").concat(fabric.parent ? fabric.parent.id : fabric.id),
    children: [fabric.title, " ", /*#__PURE__*/_jsx(ArrowRight, {})]
  }) : fabric.title;
  return /*#__PURE__*/_jsxs("div", {
    className: css.col,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.panelTitle,
      children: title
    }), /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: parseMarkdown(fabric.composition)
      }
    })]
  });
};

FabricLink.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string
};
export default /*#__PURE__*/memo(FabricLink);